/**
 * Canonical director event bus.
 * All panels must import from here — do not define event names or dispatch helpers locally.
 */

export const DIRECTOR_ADMIN_TOAST_EVENT = 'director-admin-toast';
export const DIRECTOR_DATA_UPDATED_EVENT = 'director-data-updated';
export const DIRECTOR_SCORECARD_LAYOUT_UPDATED_EVENT = 'director-scorecard-layout-updated';
export const DIRECTOR_LOCATIONS_UPDATED_EVENT = 'director-locations-updated';
// Batch 1 / B11 — coaching mutations broadcast a dedicated event so the
// follow-up count chip (Executive Snapshot), nav badge, follow-up widget
// (Director Dashboard), and the manager-side "From your director" widget
// all refresh from the same signal, no per-component polling.
export const COACHING_UPDATED_EVENT = 'coaching-updated';

export function notifyDirectorAdminToast(message, type = 'success', action = null) {
  window.dispatchEvent(new CustomEvent(DIRECTOR_ADMIN_TOAST_EVENT, {
    detail: { message, type, action }
  }));
}

export function notifyDirectorDataUpdated(message) {
  window.dispatchEvent(new CustomEvent(DIRECTOR_DATA_UPDATED_EVENT, {
    detail: { message, type: 'success' }
  }));
}

export function notifyDirectorScorecardLayoutUpdated() {
  window.dispatchEvent(new CustomEvent(DIRECTOR_SCORECARD_LAYOUT_UPDATED_EVENT));
}

export function notifyDirectorLocationsUpdated() {
  window.dispatchEvent(new CustomEvent(DIRECTOR_LOCATIONS_UPDATED_EVENT));
}

export function notifyCoachingUpdated(detail = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(COACHING_UPDATED_EVENT, { detail }));
}
